import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import {
  formatDateTime,
  formatDateTimezon,
  formattedLongDate,
} from "../../common-data/Converts";
import LeadKeywordStats from "../../automation/automation-lead-keywords/LeadKeywordStats";
import WatiLeadListingsMobile from "../mobile-uis/WatiLeadListingsMobile";
import WaitGymwiseTable from "./WaitGymwiseTable";
import {
  EyeIcon,
  CallIcon,
  PersonIcon,
  EmailIcon,
  CalenderIcon,
  ClockIconV3,
  ExcludeIcon,
} from "../../../images/icons/icons";
import CommonTable from "../../common-components/common-tables/CommonTable";

const WatiLeadListings = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
  userInfoData,
  selectedTab,
  setSelectedTab,
}) => {
  const {
    unassignedLeadsLoading,
    error,
    unassignedLeads,
    untrackedWatiLeads,
    untrackedWatiLeadsLoading,
    untrackedWatiLeadsError,
  } = useSelector((state) => state.api);

  const isAdmin = userInfoData?.account_type === "admin";

  const iniDatas = {
    pagination: [],
    allLeads: [],
    untrackedLeads: [],
    untrackedPagination: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);
  const [expandedRows, setExpandedRows] = useState({});

  const iniAllFilter = {
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {};
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const handleTabSelect = (index) => {
    setIsPage(0);
    setSelectedTab(index);
    setExpandedRows({});
  };

  useEffect(() => {
    if (
      !unassignedLeadsLoading &&
      !error &&
      unassignedLeads?.status &&
      unassignedLeads?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allLeads: unassignedLeads.data,
        pagination:
          unassignedLeads?.pagination?.length > 0
            ? unassignedLeads.pagination
            : [],
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        allLeads: [],
        pagination: [],
      }));
    }
  }, [unassignedLeadsLoading, error, unassignedLeads]);

  useEffect(() => {
    if (
      !untrackedWatiLeadsLoading &&
      !untrackedWatiLeadsError &&
      untrackedWatiLeads?.status &&
      untrackedWatiLeads?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        untrackedLeads: untrackedWatiLeads.data,
        untrackedPagination:
          untrackedWatiLeads?.pagination?.length > 0
            ? untrackedWatiLeads.pagination
            : [],
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        untrackedLeads: [],
        untrackedPagination: [],
      }));
    }
  }, [untrackedWatiLeadsLoading, untrackedWatiLeadsError, untrackedWatiLeads]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  const tbColumns = [
    {
      dataField: "added_to_lead",
      text: "Action",
      formatter: (_, row) => (
        <div className="pp-employee-payroll-actions">
          {row?.added_to_lead ? (
            <button
              key="view"
              type="button"
              className="pp-employee-payroll-action-button pp-outlined-border"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  modName: "view-lead-journey",
                  from: "wati",
                }))
              }
            >
              <EyeIcon />
              View Lead
            </button>
          ) : (
            <button
              key="add-to-lmd"
              type="button"
              className="pp-employee-payroll-action-button pp-outlined-border"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  modName: "add-to-lead",
                  from: "wati",
                }))
              }
            >
              <ExcludeIcon />
              Add To LMS
            </button>
          )}

          <button
            key="click-to-call"
            type="button"
            className="pp-employee-payroll-action-button pp-outlined-border"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "click-to-call",
                rowData: row,
              }))
            }
          >
            <CallIcon color="#000" />
            click to call
          </button>
        </div>
      ),
    },
    {
      dataField: "uid",
      text: "member info",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div
              className="tb-flex"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "view_details",
                  rowData: row,
                  from: "wati",
                }))
              }
            >
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>
              <span className="tb-data tb-link">{row?.name || "NA"}</span>
            </div>

            {row?.mobile && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <CallIcon />
                </span>
                <span className="tb-data">{row.mobile || "NA"}</span>
              </div>
            )}

            {row?.email && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <EmailIcon />
                </span>
                <span className="tb-data lowercase">{row.email || "NA"}</span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (_, row) => {
        const gymName = row?.gym_name || "NA";
        const isLong = gymName.length > 45;

        return (
          <span className={`tb-data ${isLong ? "tb-data-long" : ""}`}>
            {gymName}
          </span>
        );
      },
    },
    {
      dataField: "lead_status",
      text: "Lead Status",
      formatter: (_, row) => {
        const isNotLeadStatus = !row?.lead_status;

        return (
          <span
            className={`tb-data ${isNotLeadStatus ? "" : "tb-badge"} ${
              isNotLeadStatus
                ? ""
                : row?.lead_status === "converted"
                ? "tb-badge-success"
                : row?.lead_status === "pending"
                ? "tb-badge-success-2"
                : row?.lead_status === "closed"
                ? "not-assigned"
                : "tb-badge-success-1"
            }`}
          >
            {row?.lead_status || "NA"}
          </span>
        );
      },
    },
    selectedTab === 0 && {
      dataField: "keyword_name",
      text: "keyword name",
      formatter: (_, row) => {
        const keyword = row?.keyword_name || "NA";
        const isLong = keyword.length > 45;

        return (
          <span
            className={`tb-data lowercase ${isLong ? "tb-data-long" : ""} ${
              row?.keyword_name ? "tb-link" : ""
            }`}
            onClick={() =>
              setModValues({
                isModOpen: true,
                modName: "lead-count",
                rowData: row,
                from: "wati",
              })
            }
          >
            {row?.keyword_name || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "conversion_date",
      text: "Conversion Date",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                {" "}
                <CalenderIcon />
              </span>

              <span className="tb-data">
                {row?.conversion_date
                  ? formatDateTime(row.conversion_date)
                  : "-"}
              </span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <ClockIconV3 />
              </span>
              <span className="tb-data">{row?.conversion_days || ""}</span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "added_on_lead",
      text: "Added to LMS",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CalenderIcon />
              </span>
              <span className="tb-data">
                {row?.added_on_lead
                  ? formatDateTimezon(row.added_on_lead)
                  : "-"}
              </span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <ClockIconV3 />
              </span>
              <span className="tb-data">{row?.add_to_lms_time_dif || "-"}</span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
  ];

  const tbColumnsUnmapped = [
    {
      dataField: "added_to_lead",
      text: "Action",
      formatter: (_, row) => (
        <div className="pp-employee-payroll-actions">
          {row?.added_to_lead ? (
            <button
              key="view"
              type="button"
              className="pp-employee-payroll-action-button pp-outlined-border"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  modName: "view-lead-journey",
                  from: selectedTab === 0 ? "" : "untracked-wati-lead",
                }))
              }
            >
              <EyeIcon />
              View Lead
            </button>
          ) : (
            <button
              key="add-to-lmd"
              type="button"
              className="pp-employee-payroll-action-button pp-outlined-border"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  modName: "add-to-lead",
                  from: selectedTab === 0 ? "" : "untracked-wati-lead",
                }))
              }
            >
              <ExcludeIcon />
              Add To LMS
            </button>
          )}

          <button
            key="click-to-call"
            type="button"
            className="pp-employee-payroll-action-button pp-outlined-border"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "click-to-call",
                rowData: row,
              }))
            }
          >
            <CallIcon color="#000" />
            click to call
          </button>
        </div>
      ),
    },
    {
      dataField: "uid",
      text: "member info",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div
              className="tb-flex"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "view_details",
                  rowData: row,
                  from: "wati",
                }))
              }
            >
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>
              <span className="tb-data tb-link">{row?.name || "NA"}</span>
            </div>

            {row?.mobile && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <CallIcon />
                </span>
                <span className="tb-data">{row.mobile || "NA"}</span>
              </div>
            )}

            {row?.email && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <EmailIcon />
                </span>
                <span className="tb-data lowercase">{row.email || "NA"}</span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (_, row) => {
        const gymName = row?.gym_name || "NA";
        const isLong = gymName.length > 45;

        return (
          <span className={`tb-data ${isLong ? "tb-data-long" : ""}`}>
            {gymName}
          </span>
        );
      },
    },
    {
      dataField: "lead_status",
      text: "Lead Status",
      formatter: (_, row) => {
        const isNotLeadStatus = !row?.lead_status;

        return (
          <span
            className={`tb-data ${isNotLeadStatus ? "" : "tb-badge"} ${
              isNotLeadStatus
                ? ""
                : row?.lead_status === "converted"
                ? "tb-badge-success"
                : row?.lead_status === "pending"
                ? "tb-badge-success-2"
                : row?.lead_status === "closed"
                ? "not-assigned"
                : "tb-badge-success-1"
            }`}
          >
            {row?.lead_status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "added_on_lead",
      text: "Added to LMS",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <CalenderIcon />
              </span>
              <span className="tb-data">
                {row?.added_on_lead
                  ? formatDateTimezon(row.added_on_lead)
                  : "-"}
              </span>
            </div>

            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <ClockIconV3 />
              </span>
              <span className="tb-data">{row?.add_to_lms_time_dif || "-"}</span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "assigned_to",
      text: "assigned to",
      formatter: (_, row) => {
        return (
          <div className="tb-flex-col">
            <div className="tb-flex">
              <span className="tb-data tb-info-icon">
                <PersonIcon />
              </span>
              <span className="tb-data">{row?.assigned_to_name || "NA"}</span>
            </div>

            {row?.assigned_to_mobile && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <CallIcon />
                </span>
                <span className="tb-data">
                  {row.assigned_to_mobile || "NA"}
                </span>
              </div>
            )}

            {row?.assigned_to_email && (
              <div className="tb-flex">
                <span className="tb-data tb-info-icon">
                  <EmailIcon />
                </span>
                <span className="tb-data lowercase">
                  {row.assigned_to_email || "NA"}
                </span>
              </div>
            )}
          </div>
        );
      },
    },
    {
      dataField: "message",
      text: "message",
      formatter: (_, row) => {
        const isExpanded = expandedRows[row.uid];
        const message = row?.message || "NA";
        const words = message.split(" ");
        const shortMessage =
          words.length > 5 ? words.slice(0, 5).join(" ") + "..." : message;

        return (
          <span className="tb-data text-initial">
            {isExpanded ? (
              <>
                {message}
                <button
                  style={{
                    marginLeft: 8,
                    color: "#007bff",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    setExpandedRows((prev) => ({ ...prev, [row.uid]: false }))
                  }
                >
                  Hide
                </button>
              </>
            ) : (
              <>
                {shortMessage}
                {words.length > 5 && (
                  <button
                    style={{
                      marginLeft: 8,
                      color: "#007bff",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      setExpandedRows((prev) => ({ ...prev, [row.uid]: true }))
                    }
                  >
                    View
                  </button>
                )}
              </>
            )}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date_added ? formattedLongDate(row.date_added) : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <div className="odm-tabs-new">
        <Tabs selectedIndex={selectedTab} onSelect={handleTabSelect}>
          <TabList>
            <Tab>Mapped Keywords</Tab>
            <Tab>Unmapped Keywords</Tab>
            {isAdmin && <Tab>Wati Gymwise</Tab>}
          </TabList>

          <TabPanel>
            <LeadKeywordStats />

            <div className="common-table-container tb-bordered hideMobile mt15">
              <CommonTable
                tableData={allDatas.allLeads}
                tablePagination={allDatas.pagination}
                tableColumns={tbColumns}
                isPage={isPage}
                setIsPage={setIsPage}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
                isLoading={unassignedLeadsLoading}
              />
            </div>
            {/* <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table hideMobile">
              {unassignedLeadsLoading ? (
                <ReactVortoxSpinner />
              ) : (
                <PaymentLinkTable
                  tableData={allDatas.allLeads}
                  tableColumns={tbColumns}
                  tablePagination={allDatas.pagination}
                  isPage={isPage}
                  setIsPage={(value) => setIsPage(value)}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                  isFirstColSticky={true}
                />
              )}
            </div> */}

            <div className="lead-logs-card-container only-mobile">
              {unassignedLeadsLoading ? (
                <ReactVortoxSpinner />
              ) : (
                <WatiLeadListingsMobile
                  tableData={allDatas.allLeads}
                  tablePagination={allDatas.pagination}
                  isPage={isPage}
                  setIsPage={(value) => setIsPage(value)}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                  setModValues={setModValues}
                />
              )}
            </div>
          </TabPanel>

          <TabPanel>
            {/* <CmnFilters
              from="unmapped-keywords"
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              onClickExportBtn={() =>
                setModValues({
                  isModOpen: true,
                  modName: "export_data",
                  from: "unmapped-keywords",
                })
              }
            /> */}

            <div className="common-table-container tb-bordered hideMobile mt15">
              <CommonTable
                tableData={allDatas.untrackedLeads}
                tablePagination={allDatas.untrackedPagination}
                tableColumns={tbColumnsUnmapped}
                isPage={isPage}
                setIsPage={setIsPage}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
                isLoading={untrackedWatiLeadsLoading}
              />
            </div>

            {/* <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table hideMobile mt15">
              {untrackedWatiLeadsLoading ? (
                <ReactVortoxSpinner />
              ) : (
                <PaymentLinkTable
                  tableData={allDatas.untrackedLeads}
                  tableColumns={tbColumnsUnmapped}
                  tablePagination={allDatas.untrackedPagination}
                  isPage={isPage}
                  setIsPage={(value) => setIsPage(value)}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                  isFirstColSticky={true}
                />
              )}
            </div> */}

            <div className="lead-logs-card-container only-mobile">
              {untrackedWatiLeadsLoading ? (
                <ReactVortoxSpinner />
              ) : (
                <WatiLeadListingsMobile
                  tableData={allDatas.untrackedLeads}
                  tablePagination={allDatas.untrackedPagination}
                  isPage={isPage}
                  setIsPage={(value) => setIsPage(value)}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                  setModValues={setModValues}
                  isUntrackedWatiLead={true}
                />
              )}
            </div>
          </TabPanel>

          {isAdmin && (
            <TabPanel>
              <WaitGymwiseTable userInfoData={userInfoData} />
            </TabPanel>
          )}
        </Tabs>
      </div>
    </>
  );
};

export default WatiLeadListings;
